module.exports = __webpack_public_path__ + "img/s4.58b82e30.png";